module.exports = __webpack_public_path__ + "assets/images/cilindro_1ffc2f057e6d308e13645c783bd47973.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/cilindro/cilindro.png
// module id = 186
// module chunks = 0